import React from "react";
import { HStack, Icon, Spacer, Text, VStack } from "@chakra-ui/react";
import { CraAttribute } from "@keita/lanepatrol-sdk";
import { IoMdColorWand } from "react-icons/io";
import { CustomTooltip } from "../../../../../../shared/views/CustomTooltip";

export const AttributeWrapper = ({
  attributeDefinition,
  label,
  children,
  isSuggested,
  compact,
}: {
  label: string;
  attributeDefinition: CraAttribute;
  showLabel?: boolean;
  children: React.ReactNode;
  isSuggested?: boolean;
  compact: boolean;
}) => {
  const isSuggestedIcon = isSuggested && (
    <CustomTooltip content={"This value has been auto-filled by the system"}>
      <Icon size="md" color="primary.600" as={IoMdColorWand} />
    </CustomTooltip>
  );

  return compact ? (
    <HStack>
      <HStack width={"180px"} flexShrink={0}>
        <Text fontSize="xs" id={attributeDefinition.name}>
          {label}
        </Text>

        <Spacer />

        {isSuggestedIcon}
      </HStack>

      {children}
    </HStack>
  ) : (
    <VStack>
      <HStack alignItems="center" height={"2.2rem"}>
        <Text fontSize="sm" textAlign="center" id={attributeDefinition.name}>
          {label}
        </Text>

        {isSuggestedIcon}
      </HStack>
      {children}
    </VStack>
  );
};
